import { memo } from 'react';
import { Box, Stack, SxProps, Theme } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { ANIMATION_TIMING, bounce } from '../shared/chatAnimations';

type AnimatedDotsProps = {
  size?: 'small' | 'medium';
  variant?: 'plain' | 'aurora';
  sx?: SxProps<Theme>;
};

const AnimatedDotsComponent = ({
  size = 'small',
  variant = 'aurora',
  sx,
}: AnimatedDotsProps) => {
  const dotSize = size === 'small' ? 3 : 6;

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{ ml: 0.5, ...sx }}
    >
      {[0, 1, 2].map(index => (
        <Box
          key={index}
          sx={{
            width: dotSize,
            height: dotSize,
            borderRadius: borderRadius('xl'),
            bgcolor: variant === 'aurora' ? 'aurora.main' : 'text.secondary',
            animation: `${bounce} ${ANIMATION_TIMING.medium} ease-in-out infinite`,
            animationDelay: `${index * 0.15}s`,
          }}
        />
      ))}
    </Stack>
  );
};

export const AnimatedDots = memo(AnimatedDotsComponent);
